import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import VueTheMask from 'vue-the-mask'

import 'buefy/dist/buefy.css'
import './scss/base.scss'

Vue.use(Buefy)
Vue.use(VueTheMask)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
